export const ephreemMonths = [
    "Avus", "Anos", "Atus", "Leton", "Lexius", "Netos", "Manis", "Cerbus", "Exus", "Neres", "Silus", "Genes", "Ovus", "Retos", "Galos", "Feris", "Lenis", "Besion", "Tenor", "Olios"
]